<div class="background">
  <div class="landing-header">
    <div class="header-wrapper">
      <img src="assets/logo-skideo-text.png" alt="" />
      <h4>Data driven creative content</h4>
    </div>
  </div>

  <div class="landing-body">
    <div class="title">
      <div class="title-wrapper">
        <h1>{{ content.title }}</h1>
        <div class="date-wrapper">
          <p class="date-text">{{ content.created_at | date: 'LLL d'}}{{ suffix }} {{ content.created_at | date: 'y' }}</p>
          <p class="time-text">{{ content.created_at | date: 'HH:mm' }}</p>
        </div>
      </div>
    </div>

    <div class="content">
      @if (content.type === 3) {
        <video id="video" [src]="content.url" controls></video>
      }
      @if (content.type === 1) {
        <img id="img" [src]="content.url" />
      }
    </div>

    <div class="landing-input-wrapper">
      <div class="landing-input">
        <i class="fas fa-link input-icon"></i>
        <input [value]="url" />
        <button ngxClipboard [cbContent]="url" (click)="copyUrl()">
          <i class="far fa-clone button-icon"></i> <ng-container i18n>Copy</ng-container>
        </button>
      </div>
    </div>
  </div>
</div>
